import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function ProblemSection() {
  const questions = ['¿Tiene hambre o solo busca succión?', '¿Lo cambio o lo voy a despertar más?', '¿Lo cargo o lo acostumbro?', '¿Por qué se durmió y se despertó al bajarlo?', '¿Por qué yo siento que me voy a quebrar?'];
  return <section className="w-full bg-[#faf7f2] py-16 px-4 border-t border-[#e2e8f0]/30" data-id="element-290">
      <div className="max-w-[680px] mx-auto" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-292">
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-8" data-id="element-293">
            Esto No Es un Curso.
          </h2>

          <p className="text-lg md:text-xl leading-[1.8] text-[#2d2926] mb-8 font-light" data-id="element-294">
            No es "aprende todo sobre el sueño del bebé". Es un sistema diseñado
            para el único momento que te está destruyendo:{' '}
            <span className="font-medium text-[#0f172a]" data-id="element-295">el momento 2AM.</span>
          </p>

          <p className="text-lg md:text-xl leading-[1.8] text-[#2d2926] mb-8 font-light" data-id="element-296">
            Ese punto donde tu cabeza no funciona, tu cuerpo tiembla del
            cansancio, y aún así tienes que decidir rápido:
          </p>

          <ul className="space-y-4 mb-10 pl-4 border-l-2 border-[#e8856c]/30" data-id="element-297">
            {questions.map((q, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3 text-lg text-[#475569]" data-id="element-298">
                <HelpCircle className="w-5 h-5 text-[#5b8a7a] mt-1 shrink-0" data-id="element-299" />
                <span data-id="element-300">{q}</span>
              </motion.li>)}
          </ul>

          <p className="text-lg md:text-xl leading-[1.8] text-[#2d2926] mb-6 font-light" data-id="element-301">
            Y lo peor: no puedes "pensar bien" porque estás sin dormir. Entonces
            haces lo más humano:
          </p>

          <div className="bg-[#f5f0e8] p-6 rounded-lg border border-[#e2e8f0] text-center" data-id="element-302">
            <p className="font-serif text-xl italic text-[#0f172a]" data-id="element-303">
              Pruebas cosas al azar.
            </p>
            <p className="text-[#e8856c] font-medium mt-2" data-id="element-304">
              Y el azar… suele alargar la noche.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}